export default __webpack_public_path__ + "media/images/admin/arrow-left-48d44d855002b0c98ea590fe022c51b2.svg";